<template lang="pug">
  .app-header.w-full.trans-theme.leading-none.tracking-40.pb-24.font-numbers-normal(:class="theme === 'dark' ? 'text-white' : 'text-black'", @mouseenter="$emit('hover')", @mouseleave="$emit('hoverEnd')")
    //- logo (A5: the wordmark does not move or resize with the type changes)
    .absolute.z-10.top-0.left-0.w-full.px-12.h-topbar-lg.lg-pb-26.pointer-events-none.flex.items-end
      .w-4x18.px-12.text-24.font-medium.whitespace-no-wrap(style="line-height:0.75")
          a.pointer-events-auto(href="/", @click.prevent="$emit('refresh')") Guido van Helten

    //- bar
    .flex.items-end.px-12.h-topbar-lg.relative.lg-pb-26(:style="{transform: collapsed ? 'translateY(-25%)' : 'none'}", style="transform-origin:left bottom; transition: opacity 150ms, transform 150ms, background-color 150ms", :class="{'opacity-0': collapsed, 'bg-white': y > 10 && canCollapse}")
      //- logo space
      .w-4x18.px-12

      //- main nav (A1-A3) — taken out of the column flow so it can be centred
      //- within a margin-aligned box (not the full page width); it stays
      //- inside the bar to keep the collapse animation
      .absolute.top-0.left-0.w-11x18.px-12.h-topbar-lg.lg-pb-26.pointer-events-none.flex.items-end.justify-center
        transition(name="quickfade")
          nav.app-header__nav.px-12.type-nav.whitespace-no-wrap(v-show="!hideNav")
            router-link.inline-block.mr-2sp.pointer-events-auto(:to="{name: 'home'}") Selected Works
            router-link.inline-block.mr-2sp.pointer-events-auto.app-header__parent-rt(:to="{name: 'projects'}") Projects
            router-link.inline-block.mr-2sp.pointer-events-auto(:to="{name: 'page', params: {uid: 'info'}}") About
            router-link.inline-block.mr-2sp.pointer-events-auto(:to="{name: 'page', params: {uid: 'press'}}") Press
            router-link.inline-block.mr-2sp.pointer-events-auto(:to="{name: 'editions'}") Shop

      //- (project: scroll nav)
      nav.app-header__nav.hidden.xl-block.w-4x18.px-12.type-nav.trans-opacity-quick.whitespace-no-wrap(v-show="!hideNav && showPrjNav", :class="!nav && 'opacity-0'")
        button.inline-block.mr-2sp(v-scroll-to="'#prj-mural'", :class="{'font-medium': active === 'prj-mural'}") Mural
        button.inline-block.mr-2sp(v-scroll-to="{el: '#prj-body', offset: -144}", :class="{'font-medium': active === 'prj-body'}") Text
        button.hidden.mr-2sp(v-for="(itm, i) in nav", v-scroll-to="{el: '#' + idy(itm), offset: -144}", :class="{'lg-inline-block': !i, 'xl-inline-block': i > 0, 'font-medium': active === idy(itm)}") {{itm}}

      //- secondary menus — mirrored: the main menu is centred inside the left 11/18 box,
      //- so these sit centred inside the matching box on the right rather than hard
      //- against the page margin
      .absolute.top-0.right-0.w-11x18.px-12.h-topbar-lg.lg-pb-26.pointer-events-none.flex.items-end.justify-center
        .type-nav.px-12.pointer-events-none
          //- (projects: view nav, A4)
          nav.app-header__nav.whitespace-no-wrap(v-show="!hideNav && $route.name === 'projects'")
            router-link.pointer-events-auto(:to="{query: {view: 'gallery'}}", :class="{'font-medium': isGalleryView}").inline-block.mr-2sp Gallery
            router-link.pointer-events-auto(:to="{query: {view: 'map'}}").inline-block.mr-2sp Map
            router-link.pointer-events-auto(:to="{query: {view: 'archive'}}", :class="{'font-medium': $route.query.view === 'text'}").inline-block Archive

          //- page nav (matching the projects view nav)
          nav.whitespace-no-wrap.trans-opacity-quick(v-show="!hideNav && $route.name === 'page'", :class="!nav && 'opacity-0'")
            button.pointer-events-auto(v-for="(itm, i) in nav", v-scroll-to="{el: '#' + idy(itm)}", :class="{'font-medium': active === idy(itm), 'mr-2sp': i < nav.length - 1}") {{itm}}

          //- project nav (previous / next)
          project-nav.app-header__prj-nav(v-show="!hideNav && showPrjNav", :uid="$route.name === 'home' ? inlinePrj : null")

      //- bag link stays a utility, rightmost like the wordmark is leftmost
      .flex-1.flex.justify-end.type-nav.px-12
        router-link.block.whitespace-no-wrap.ml-2sp(v-if="cartCount", :to="{name: 'cart'}") {{ cartCount }} Bag
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { idy } from '@/utils'
import ProjectNav from '@/components/Project/ProjectNav'
export default {
  name: 'AppHeader',
  props: ['hideNav', 'collapsed', 'y', 'canCollapse'],
  data () {
    return {
      idy: idy,
      sections: []
    }
  },
  computed: {
    ...mapState(['theme', 'bus', 'nav', 'inlinePrj', 'inlinePrjActive']),
    ...mapGetters({ cartCount: 'shop/cartCount' }),
    active () {
      // active scroll pt in scroll nav
      const sec = this.sections.find(sec => this.y >= sec.top)
      return sec && sec.id
    },
    isGalleryView () {
      const v = this.$route.query.view
      return !v || v === 'image'
    },
    // project tools also show while scrolled into the project rendered under the Selected Works slideshow
    showPrjNav () {
      return this.$route.name === 'project' || (this.$route.name === 'home' && this.inlinePrjActive)
    }
  },
  methods: {
    setSections (delay = 800) {
      setTimeout(() => {
        const els = document.querySelectorAll('.scroll-pt')
        const top = window.pageYOffset
        this.sections = []
        els.forEach(el => this.sections.push(
          { id: el.getAttribute('id'), top: el.getBoundingClientRect().top + top - 144 }
        ))
        this.sections.reverse()
      }, delay)
    }
  },
  watch: {
    nav () {
      this.setSections()
    }
  },
  components: { ProjectNav }
}
</script>

<style>
/* the mirrored secondary-menu box is click-through; its own links opt back in */
.app-header__prj-nav a { pointer-events: auto; }

.app-header .app-header__nav .router-link-exact-active,
.app-header .app-header__parent-rt.router-link-active.router-link-active {
  font-weight: 500
}
</style>
